import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {ConfigService} from './config.service';
import {Observable, throwError} from 'rxjs';
import {
  EventlinkInterface,
  EventlinkInterfaceAPI, EventsInterfaceAPI, SPIInterfaceAPI, SPSInterfaceAPI
} from '@auth-suite-services/suredebit-setup';
import {catchError} from 'rxjs/operators';
import {BasicResponse} from '@auth-suite-services/services';
import {TempsInterfaceAPI} from '../..';

@Injectable({
  providedIn: 'root'
})
export class EventlinksService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(ConfigService) private config: any, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'SDSETUP').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  getAllEventLinks(pageIndex: number, pageSize: number, sortActive: string, sort: string): Observable<EventlinkInterfaceAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<EventlinkInterfaceAPI>(`${this.URL}/eli/getalleventlinks/${pageIndex}/${pageSize}/${sortActive ? sortActive : 'id'}/${sort ? sort : 'asc'}`, {headers}).pipe(catchError(this.handleError));
  }

  getEventLinks(id: number): Observable<EventlinkInterface> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(id);
    const headers = this.headers;
    return this.httpClient.get<EventlinkInterface>(`${this.URL}/eli/geteventlink/${id}`, {headers}).pipe(catchError(this.handleError));
  }

  updateELI(eli: EventlinkInterface): Observable<BasicResponse> {
    const headers = this.headers;
    const payload = {
      ...eli,
      id: Number(eli.id),
      UACID: eli?.UACID != null ? Number(eli.UACID) : eli?.UACID
    };
    console.log('Update eli: ' + JSON.stringify(payload));
    return this.httpClient.post<BasicResponse>(`${this.URL}/eli/updateeventlink`, payload, {headers}).pipe(catchError(this.handleError));
  }

  createELI(eli: EventlinkInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Create eli: ' + JSON.stringify(eli));
    return this.httpClient.post<BasicResponse>(`${this.URL}/eli/createeventlink`, eli, {headers}).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }

  getAllEvents(): Observable<EventsInterfaceAPI> {
    const headers = this.headers;
    return this.httpClient.get<EventsInterfaceAPI>(`${this.URL}/eli/getallevents`, {headers}).pipe(
        catchError(this.handleError));
  }

  getAllSPI(): Observable<SPIInterfaceAPI> {
    const headers = this.headers;
    return this.httpClient.get<SPIInterfaceAPI>(`${this.URL}/eli/getallspi`, {headers}).pipe(
        catchError(this.handleError));
  }

  getAllSPS(): Observable<SPSInterfaceAPI> {
    const headers = this.headers;
    return this.httpClient.get<SPSInterfaceAPI>(`${this.URL}/eli/getallsps`, {headers}).pipe(
        catchError(this.handleError));
  }

  getAllTemplates(): Observable<TempsInterfaceAPI> {
    const headers = this.headers;
    return this.httpClient.get<TempsInterfaceAPI>(`${this.URL}/eli/getalltemplates`, {headers}).pipe(
        catchError(this.handleError));
  }

  
  //added call to set status                                            22/11/23 CN
  setEventLinkStatus(id: {id: number}): Observable<BasicResponse> {
    console.log("======================================================================");
    console.log(id.id);
    console.log("======================================================================");
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(`${this.URL}/eli/seteventlinkstatus/${id.id}`, {headers}).pipe(catchError(this.handleError));
  }
}
